export default "__VITE_ASSET__qg1yJfYT__"